
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import { Link, Image } from 'contentbricks'
import { M, I } from './_elements.tsx'

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>{`ährend wir schlafen, gibt unser Körper nicht nur Talg, Salze und Harnstoff ab, sondern im Schnitt auch einen Liter Feuchtigkeit. Ein Teil davon wird von der Bettdecke oder der Matratze aufgenommen. Eine regelmässige und gründliche Pflege ist deshalb wichtig. `}<br /><br /><b>{`Das sollten Sie dazu wissen:`}</b></p>
    <I mdxType="I">Lüften ist das A und O der Matratzenpflege. Tagsüber sollte das Bett möglichst nicht zugedeckt werden, damit Luft zur Matratze gelangen kann. Zudem sollte die Matratze erhöht auf einem Lattenrost liegen, damit auch von unten Luft hinzukommt.</I>
    <I mdxType="I">Wendbare Matratzen sollten mindestens alle zwei bis drei Monate gewendet werden. Auch eine regelmässige 180-Grad-Drehung wird empfohlen – zumindest bei geeigneten Modellen. Dadurch kann sich die Matratze an den stark beanspruchten Stellen erholen und wieder in ihren Urzustand zurückfinden.</I>
    <I mdxType="I">Wirklich hygienisch bleibt es in unseren Betten nur, wenn die Matratze hin und wieder gereinigt wird – am besten in der Maschine. Matratzenbezüge sollten alle drei Monate gewaschen werden. Ziehen Sie dazu die Pflegeanleitung des Herstellers zurate.</I>
    <I mdxType="I">Vor einem direkten Absaugen wird abgeraten. Der Inhalt der Matratzenauflage könnte so beschädigt werden.</I>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;